import React, { useEffect, useState } from "react";
import TextArea from "../ReusableComponents/TextArea";
import InputText from "../ReusableComponents/InputText";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import DropDown from "../ReusableComponents/DropDown";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import GridPageWithCheckBox from "../components/GridPageWithCheckBox";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import toast from "react-hot-toast";
import UsePrevious from "../Hook/UsePrevious";
import { isValid } from "date-fns";
import { laundryHeader } from "../components/HeaderAttribute";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import MainPopup from "../popup-containers/MainPopup";
import LaundryPopup from "../popup-containers/LaundryPopup";
// import GridPage from "../components/GridPage"; // Uncomment if needed

const Laundry = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setupdateScreenTitle] = useState(false);
  const [visibleReceive, setVisibleReceive] = useState(false);
  const [checkBoxStatus, setCheckBoxStatus] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [MstLaundryIssueId, setMstLaundryIssueId] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [popUpData, setPopUpData] = useState(null);
  const [popUpDataDD, setPopUpDataDD] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [itemTypeDD, setItemTypeDD] = useState([]);
  const [categoryDD, setCategoryDD] = useState([]);
  const [bindLaundryChildDatas, setBindLaundryChildDatas] = useState([]);
  const [LaundryChildData, setLaundryChildData] = useState([]);
  const [nameDD, setNameDD] = useState([]);
  const [issueToDD, setIssueToDD] = useState([]);
  const [issuedByDD, setIssuedByDD] = useState([]);
  const [receivedFormDD, setreceivedFormDD] = useState([]);
  const [receivedByDD, setreceivedByDD] = useState([]);
  const [LaundryIssueId, setLaundryIssueId] = useState("");
  const [bindLaundryIssueDatas, setbindLaundryIssueDatas] = useState([]);

  var createdBy = sessionStorage.getItem("createdBy");
  const [MstLaundryId, setMstLaundryId] = useState("");
  const [laundryIssueData, setLaundryIssueData] = useState([]);
  const [bindLaundryMaster, setBindLaundryMaster] = useState([]);

  const [formFields, setFormFields] = useState({
    issueNo: "LIS",
    date: "",
    issuedTo: "",
    issuedBy: "",
    remarks: "",
    receiptNo: "LRE",
    receivedFrom: "",
    receivedBy: "",
  });

  //Show error message
  const [formFieldsError, setFormFieldsError] = useState({
    issueNoError: "",
    dateError: "",
    issuedToError: "",
    issuedByError: "",
    receiptNoError: "",
    receivedFromError: "",
    receivedByError: "",
  });

  const [tableData, setTableData] = useState([
    {
      itemType: "",
      itemCategory: "",
      itemName: "",
      quantity: "",
      rate: "",
      itemCategoryList: [],
      itemNameList: [],
    },
  ]);

  // Bind gird datas
  useEffect(() => {
    bindLaundryIssue();
  }, []);
  const previousTableData = UsePrevious(tableData);
  const bindLaundryIssue = async () => { 
    
    const response = await BindAPI("LaundryIssueAPI/BindLaundryIssue");
    console.log("issue", response);
    if (response && response.data) {
      setLaundryIssueData(response.data.Table);
      console.log(response.data.Table[1]);
      setTableData([response.data.Table[1]]);

      const laundryMasterData = response.data.Table.map((item) => ({
        value: item.MstLaundryMasterId,
        label: item.LaundryMaster,
      }));

      setBindLaundryMaster(laundryMasterData);
    } else {
      setBindLaundryMaster([]);
    }
  };
  const getItemTypeDDValues = async () => {
    const response = await BindAPI("ItemsAPI/BindItemType");
    const getItemTypeId =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
            value: item.MstItemTypeId,
            label: item.ItemType,
          }))
        : [];
    setItemTypeDD(getItemTypeId);
  };

  const categoriesDropDown = async () => {
    
    const response = await BindAPI("ItemsAPI/BindItemCategory");
    const response1 = await BindAPI("ItemsAPI/BindItems");
    const response2 = await BindAPI("StaffMasterAPI/ BindStaffMaster");
    const response3 = await BindAPI("LaundryMasterAPI/BindLaundryMaster");
    console.log(response3);

    const getIsuedToId =
      response2.data.Table && response2.data.Table.length > 0
        ? response2.data.Table.map((item) => ({
            value: item.MstStaffId,
            label: item.FullName,
          }))
        : [];
    setIssueToDD(getIsuedToId);
    
    const getIssuedById =
      response3.data.Table && response3.data.Table.length > 0
        ? response3.data.Table.map((item) => ({
            value: item.MstLaundryId,
            label: item.LaundryName,
          }))
        : [];

    console.log(getIssuedById);

    setIssuedByDD(getIssuedById);
    setCategoryDD(response.data.Table);
    setNameDD(response1.data.Table);
  };

  useEffect(() => {
    // getCommodityUOMDDValues();
    getItemTypeDDValues();
    categoriesDropDown();
  }, []);

  useEffect(() => {
    const updateTableData = async () => {
      if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
        const updatedTableData = [...tableData]; // Clone the current table data

        // Iterate through each row
        for (const row of updatedTableData) {
          if (row?.itemType) {
            const getFilteredCategory = categoryDD
              .filter((item) => item.MstItemTypeId === row.itemType)
              .map((item) => ({
                value: item.MstItemCategoryId,
                label: item.ItemCategory,
              }));
            row.itemCategoryList = getFilteredCategory;
          }

          if (row?.itemCategory) {
            const selectedCommoditiesCategory = nameDD
              .filter((item) => item.MstItemCategoryId === row.itemCategory)
              .map((item) => ({
                value: item.MstItemId,
                label: item.ItemName,
              }));
            row.itemNameList = selectedCommoditiesCategory;
          }
        }

        setTableData(updatedTableData);
      }
    };

    updateTableData();
  }, [tableData]);

  // Validation Error
  const validateForm = () => {
    const errors = {
      issueNoError: formFields.issueNo ? "" : "Enter Issue No",
      dateError: formFields.date ? "" : "Enter Date",
      issuedToError: formFields.issuedTo ? "" : "Select Issued To",
      issuedByError: formFields.issuedBy ? "" : "Select Issued By",
      receiptNoError: formFields.receiptNo ? "" : "Enter Receipt No",
      receivedFromError: formFields.receivedFrom ? "" : "Select Received From",
      receivedByError: formFields.receivedBy ? "" : "Select Received By",
    };
    setFormFieldsError(errors);
    return Object.values(errors).every((err) => err === "");
  };

  function formatToDDMMYYYY(dateTimeStr) {
    const date = new Date(dateTimeStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const appendDataToCommoditiesTable = () => {};

  const handleEdit = (rowIndex) => {
    
    const rowData = laundryIssueData[rowIndex];
    console.log(rowData);
    setSelectedRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setupdateScreenTitle(true);
    const dateTime = new Date(rowData.IssueDate);
    const dateOnly = formatToDDMMYYYY(rowData.IssueDate); // Default locale (e.g., "7/7/2025")
    console.log(dateOnly);
    setFormFields({
      ...formFields,
      issueNo: rowData.IssueNo,

      date: dateOnly,
      issuedTo: rowData.MstIssuedToId,
      isssuedBy: rowData.MstIssuedById,
      // receiptNo: bindLaundryMaster[rowData].ReceiptNo,
      date: rowData.ReceivedDate,
      // receivedFrom: bindLaundryMaster[rowData].MstReceivedFrom,
      // receivedBy: bindLaundryMaster[rowData].MstReceivedBy,
    });

    if (LaundryChildData.length > 0) {
      setTableData(LaundryChildData);
    } else {
      // If no data, set empty row for manual edit
      setTableData([
        {
          itemType: "",
          itemCategory: "",
          itemName: "",
          quantity: "",
          rate: "",
          itemCategoryList: [],
          itemNameList: [],
        },
      ]);
    }
  };

  const showAdd = (rowIndex) => {
    
    setVisibleTable(false);
    setAddScreenTitle(true);
    setupdateScreenTitle(false);
    setVisibleAdd(true);
  };
  const showReceive = (rowIndex) => {
    setVisibleTable(false);
    setAddScreenTitle(true);
    setupdateScreenTitle(false);
    setVisibleReceive(true);
    setVisibleAdd(false);
  };
  // const handleInputChange = (e, index) => {
  //   const { name, value } = e.target;
  //   const newTableData = [...tableData];
  //   newTableData[index][name] = value;
  //   setTableData(newTableData);
  // };
  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setLaundryIssueId(jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  const handleInputChange = (selectedOption, rowIndex, columnName) => {
    
    const value = selectedOption.value
      ? selectedOption.value
      : selectedOption.target.value;
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };

  const handleInputChangeForm = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const newErrors = { ...formFieldsError };
    if (!value) {
      newErrors[name] = "This field is required";
    } else {
      delete newErrors[name];
    }
    setFormFieldsError(newErrors);
  };

  const handleDeleteRow = (index) => {
    const newTableData = [...tableData];
    newTableData.splice(index, 1);
    setTableData(newTableData);
  };

  const handleAddRow = () => {
    if (tableData.length < 4) {
      setTableData([...tableData, { laundryItem: "", quantity: 0 }]);
    }
  };

  const cancel = () => {
    // Reset form or navigate back
    setVisibleAdd(false);
    setVisibleTable(true);
    setupdateScreenTitle(false);
    setVisibleReceive(false);
  };

  const handleLaundry = (rowIndex, flag) => {
    setpopUpOpen(true);

    const rowData = bindLaundryIssue?.[rowIndex];
    if (!rowData) {
      console.error("No row found at index:", rowIndex);
      return;
    }

    setMstLaundryId(rowData.MstLaundryIssueId);
    setPopUpData(rowData);
    setPopUpDataDD(bindLaundryIssue);

    // Flag handling
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }

    if (LaundryChildData.length === 0) {
      setTableData([
        {
          itemType: "",
          itemCategory: "",
          itemName: "",
          quantity: "",
          rate: "",
          itemCategoryList: [],
          itemNameList: [],
        },
      ]);
    } else {
      appendDataToCommoditiesTable(JSON.stringify(LaundryChildData));
    }
  };

  const handle1 = (value) => {
    setSelectedRows(value);
    setCheckBoxStatus(value);
  };

  const handleSubmit = async (items, flag) => {
    
    // setSubmitBtnDisabled(true);
    const createdBy = sessionStorage.getItem("createdBy");

    if (flag == 1 || flag == 2) {
      const Laundry = validateForm(flag);
      if (Object.keys(Laundry).length !== 0) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
      if (true) {
        setIsOpen(false);
        setIsLoading(true);
        const data = {
          mstLaundryIssueId: MstLaundryIssueId ? MstLaundryIssueId : 0,
          issueNo: formFields.issueNo,
          issueDate: formFields.date,
          mstIssuedToId: formFields.issuedTo,
          mstIssuedById: formFields.issuedBy,
          laundryIssue: LaundryIssueId,
          remarks: formFields.remarks,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI(data, "LaundryIssueAPI/IUDLaundryIssue");
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("LaundyIssue data inserted successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Amenities data insert failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        }
      }
    }
  };

  const [laundryrecord, setLaundryRecord] = useState("");

  const laundryData = (index, flag) => {
    //const rowData = laundryIssueData[index];
    const rowData = laundryIssueData?.[index];
    setSelectedRowIndex(index);

    if (!rowData) {
      console.error("No data found at index", index);
      return;
    }

    setSelectedRowIndex(index);
    setpopUpOpen(true);

    // if(flag===1){
    console.log("val:", index);
    //setrowIndex(rowIndex);
    //setpopUpOpen(true);

    const laundrydata = {
      issuedate: rowData.IssueDate,
      issueno: rowData.IssueNo,
      laundryname: rowData.LaundryName,
      mstissuedbyid: rowData.MstIssuedById,
      mstissuedtoid: rowData.MstIssuedToId,
      remarks: rowData.Remarks,
      totalquantity: rowData.TotalQuantity,
    };
    setLaundryRecord(laundrydata);
    //}
  };
  return (
    <MainLayout pageName={"3"}>
      {visibleTable && (
        <GridPageWithCheckBox
          title="Laundry"
          header={laundryHeader}
          checkBoxVisible={true}
          checkBoxStatus={handle1}
          selectedRows={selectedRows ?? []}
          records={laundryIssueData}
          handleEdit={handleEdit}
          handleAction={handleLaundry}
          showAdd={showAdd}
          showReceive={showReceive}
          blockView={false}
          addView={false}
          receiveView={true}
        />
      )}

      {visibleAdd && (
        <div className="w-full">
          <div className={mainTable.grid2}>
            <div className="clientMasterMainAdd">
              <AddScreenTitle
                title="Laundry Issue"
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
              />
            </div>
          </div>
          <div className="shadow-md p-4 rounded-md bg-white">
            <form onSubmit={handleSubmit}>
              <div className="grid gap-6 mb-4 md:grid-cols-4 flex justify-center items-center">
                <InputText
                  inputType="text"
                  title="Issue No"
                  name="issueNo"
                  disabled={true}
                  placeholder="Issue No"
                  classStar="text-red-500"
                  content={formFields.issueNo}
                  controlFunc={(e) =>
                    setFormFields({
                      ...formFields,
                      issueNo: e.target.value,
                    })
                  }
                  controlFuncBlur={validateForm}
                  errorMessage={formFieldsError.issueNoError}
                  // tabIndex="1"
                />

                <InputText
                  inputType="date"
                  title="Issue Date"
                  classStar="text-red-500"
                  name="date"
                  content={formFields.date}
                  controlFunc={(e) =>
                    setFormFields({
                      ...formFields,
                      date: e.target.value,
                    })
                  }
                  controlFuncBlur={validateForm}
                  errorMessage={formFieldsError.dateError}
                  // tabIndex="1"
                />

                <DropDown
                  title="Issued To"
                  name="issuedTo"
                  classStar="text-red-500"
                  options={issueToDD}
                  selectedOption={formFields.issuedTo}
                  placeholder="Select Issued To"
                  controlFunc={(e) =>
                    setFormFields({
                      ...formFields,
                      issuedTo: e.target.value,
                    })
                  }
                  controlFuncBlur={validateForm}
                  errorMessage={formFieldsError.issuedToError}
                  // tabIndex="1"
                />

                <DropDown
                  title="Issued By"
                  name="issuedBy"
                  classStar="text-red-500"
                  options={issuedByDD}
                  selectedOption={formFields.issuedBy}
                  placeholder="Select Issued By"
                  controlFunc={(e) =>
                    setFormFields({
                      ...formFields,
                      issuedBy: e.target.value,
                    })
                  }
                  controlFuncBlur={validateForm}
                  errorMessage={formFieldsError.issuedByError}
                  // tabIndex="1"
                />
              </div>

              <table className="min-w-full border border-gray-300">
                <thead className="bg-[#3D6643] text-left">
                  <tr>
                    <th className="border px-0.5 py-2 w-[20px]">S.No</th>
                    <th className="border px-4 py-2 w-[180px]">Item Type</th>
                    <th className="border px-4 py-2 w-[180px]">Category</th>
                    <th className="border px-4 py-2 w-[180px]">Name</th>
                    <th className="border px-4 py-2 w-[80px]">Quantity</th>
                    <th className="border px-4 py-2 w-[80px]">Rate</th>
                    <th className="border px-4 py-2 w-[80px]">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr key={index}>
                      <td className="border px-2 py-2 w-[1px]">{index + 1}</td>
                      <td className="border px-4 py-2">
                        <AutoDropDown
                          options={itemTypeDD}
                          placeholder="Select"
                          name="itemType"
                          Class="p-0"
                          selectedOption={itemTypeDD.find(
                            (x) => x.value == row.itemType
                          )}
                          controlFunc={(e) => {
                            handleInputChange(e, index, "itemType");
                          }}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <AutoDropDown
                          options={row.itemCategoryList || []}
                          placeholder="Select"
                          name="itemCategory"
                          Class="p-0"
                          selectedOption={
                            row.itemCategoryList && row.itemCategoryList
                              ? row.itemCategoryList.find(
                                  (x) => x.value === row.itemCategory
                                )
                              : null
                          }
                          controlFunc={(e) => {
                            handleInputChange(e, index, "itemCategory");
                          }}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <AutoDropDown
                          options={row.itemNameList || []}
                          placeholder="Select"
                          name="name"
                          Class="p-0"
                          selectedOption={
                            row.itemNameList && row.itemNameList
                              ? row.itemNameList.find(
                                  (x) => x.value === row.itemName
                                )
                              : null
                          }
                          controlFunc={(e) => {
                            handleInputChange(e, index, "itemName");
                          }}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <InputText
                          inputType="text"
                          name="quantity"
                          controlFunc={(e) =>
                            handleInputChange(e, index, "quantity")
                          }
                          controlFuncBlur={handleBlur}
                          content={row.quantity}
                          placeholder=""
                          // tabIndex="11"
                          isRequired={true}
                          errorMessage={formFieldsError.quantity}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <InputText
                          inputType="text"
                          name="rate"
                          controlFunc={(e) =>
                            handleInputChange(e, index, "rate")
                          }
                          controlFuncBlur={handleBlur}
                          content={row.rate}
                          placeholder=""
                          // tabIndex="11"
                          isRequired={true}
                          errorMessage={formFieldsError.quantity}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <div className="flex gap-4 items-center justify-center">
                          <svg
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            className="w-6 h-6 text-black cursor-pointer"
                            onClick={() => handleDeleteRow(index)}
                          >
                            <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                          </svg>
                          {index === tableData.length - 1 &&
                            tableData.length < 4 && (
                              <svg
                                viewBox="0 0 1024 1024"
                                fill="currentColor"
                                onClick={handleAddRow}
                                className="w-6 h-6 text-black cursor-pointer"
                              >
                                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                              </svg>
                            )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <br></br>

              <TextArea
                title="Remarks"
                name="remarks"
                placeholder="Remarks"
                row={2}
                // tabIndex="1"
                maxLength={500}
                content={formFields.remarks}
                controlFunc={handleInputChangeForm}
                controlFuncBlur={handleBlur}
              />

              <div className="col-span-2 flex justify-center mt-6 gap-4">
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
              </div>
            </form>
          </div>
        </div>
      )}

      {visibleReceive && (
        <div className="w-full">
          <div className={mainTable.grid2}>
            <div className="clientMasterMainAdd">
              <AddScreenTitle
                title="Laundry Received"
                addScreenTitle={AddScreenTitle}
                updateScreenTitle={updateScreenTitle}
              />
            </div>
          </div>
          <div className="shadow-md p-4 rounded-md bg-white">
            <form onSubmit={handleSubmit}>
              <div className="grid gap-6 mb-4 md:grid-cols-4 flex justify-center  items-center">
                <InputText
                  title="Receipt No"
                  name="receiptNo"
                  placeholder="Receipt No"
                  disabled={true}
                  // tabIndex="1"
                  content={formFields.receiptNo}
                  controlFunc={(e) =>
                    setFormFields({
                      ...formFields,
                      receiptNo: e.target.value,
                    })
                  }
                  controlFuncBlur={validateForm}
                  errorMessage={formFieldsError.receiptNoError}
                />

                <InputText
                  inputType="date"
                  title="Received Date"
                  classStar="text-red-500"
                  name="date"
                  content={formFields.date}
                  controlFunc={(e) =>
                    setFormFields({
                      ...formFields,
                      date: e.target.value,
                    })
                  }
                  controlFuncBlur={validateForm}
                  errorMessage={formFieldsError.dateError}
                  // tabIndex="1"
                />

                <DropDown
                  title="Received From"
                  name="receivedFrom"
                  placeholder="Select Received From"
                  classStar="text-red-500"
                  options={receivedFormDD}
                  selectedOption={formFields.receivedFrom}
                  controlFunc={(e) =>
                    setFormFields({
                      ...formFields,
                      receivedFrom: e.target.value,
                    })
                  }
                  controlFuncBlur={validateForm}
                  errorMessage={formFieldsError.receivedFromError}
                  // tabIndex="1"
                />
                <DropDown
                  title="Received By"
                  name="receivedBy"
                  placeholder="Select Issued By"
                  classStar="text-red-500"
                  options={receivedByDD}
                  selectedOption={formFields.receivedBy}
                  controlFunc={(e) =>
                    setFormFields({
                      ...formFields,
                      receivedBy: e.target.value,
                    })
                  }
                  controlFuncBlur={validateForm}
                  errorMessage={formFieldsError.receivedByError}
                  // tabIndex="1"
                />
              </div>

              <table className="min-w-full table-auto border border-gray-300">
                <thead className="bg-[#3D6643] text-left">
                  <tr>
                    <th className="border px-2 py-2 w-[30px]">S.No</th>
                    <th className="border px-4 py-2 w-[180px]">Item Type</th>
                    <th className="border px-4 py-2 w-[180px]">Category</th>
                    <th className="border px-4 py-2 w-[180px]">Name</th>
                    <th className="border px-4 py-2 w-[80px]">
                      Issued Quantity
                    </th>
                    <th className="border px-4 py-2 w-[80px]">
                      Received Quantity
                    </th>
                    <th className="border px-4 py-2 w-[80px]">Rate</th>
                    <th className="border px-4 py-2 w-[80px]">Balance</th>
                    <th className="border px-2 py-2 w-[80px]">Damage</th>
                    <th className="border px-4 py-2 w-[80px]">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr key={index}>
                      <td className="border px-2 py-2 w-[30px]">{index + 1}</td>
                      <td className="border px-4 py-2">
                        <AutoDropDown
                          options={itemTypeDD}
                          placeholder="Select"
                          name="itemType"
                          Class="p-0"
                          selectedOption={itemTypeDD.find(
                            (x) => x.value == row.itemType
                          )}
                          controlFunc={(e) => {
                            handleInputChange(e, index, "itemType");
                          }}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <AutoDropDown
                          options={row.itemCategoryList || []}
                          placeholder="Select"
                          name="itemCategory"
                          Class="p-0"
                          selectedOption={
                            row.itemCategoryList && row.itemCategoryList
                              ? row.itemCategoryList.find(
                                  (x) => x.value === row.itemCategory
                                )
                              : null
                          }
                          controlFunc={(e) => {
                            handleInputChange(e, index, "itemCategory");
                          }}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <AutoDropDown
                          options={row.itemNameList || []}
                          placeholder="Select"
                          name="name"
                          Class="p-0"
                          selectedOption={
                            row.itemNameList && row.itemNameList
                              ? row.itemNameList.find(
                                  (x) => x.value === row.itemName
                                )
                              : null
                          }
                          controlFunc={(e) => {
                            handleInputChange(e, index, "itemName");
                          }}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <InputText
                          inputType="text"
                          name="issuedquantity"
                          controlFunc={(e) => handleInputChange(e, index)}
                          controlFuncBlur={handleBlur}
                          content={row.quantity}
                          placeholder=""
                          // tabIndex="11"
                          isRequired={true}
                          errorMessage={formFieldsError.quantity}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <InputText
                          inputType="text"
                          name="receivedquantity"
                          controlFunc={(e) => handleInputChange(e, index)}
                          controlFuncBlur={handleBlur}
                          content={row.quantity}
                          placeholder=""
                          // tabIndex="11"
                          isRequired={true}
                          errorMessage={formFieldsError.quantity}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <InputText
                          inputType="text"
                          name="Rate"
                          controlFunc={(e) => handleInputChange(e, index)}
                          controlFuncBlur={handleBlur}
                          content={row.quantity}
                          placeholder=""
                          // tabIndex="11"
                          isRequired={true}
                          errorMessage={formFieldsError.quantity}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <InputText
                          inputType="text"
                          name="Balance"
                          controlFunc={(e) => handleInputChange(e, index)}
                          controlFuncBlur={handleBlur}
                          content={row.quantity}
                          placeholder=""
                          // tabIndex="11"
                          isRequired={true}
                          errorMessage={formFieldsError.quantity}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <InputText
                          inputType="text"
                          name="Damage"
                          controlFunc={(e) => handleInputChange(e, index)}
                          controlFuncBlur={handleBlur}
                          content={row.quantity}
                          placeholder=""
                          // tabIndex="11"
                          isRequired={true}
                          errorMessage={formFieldsError.quantity}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <div className="flex gap-4 items-center justify-center">
                          <svg
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            className="w-6 h-6 text-black cursor-pointer"
                            onClick={() => handleDeleteRow(index)}
                          >
                            <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                          </svg>
                          {index === tableData.length - 1 &&
                            tableData.length < 4 && (
                              <svg
                                viewBox="0 0 1024 1024"
                                fill="currentColor"
                                onClick={handleAddRow}
                                className="w-6 h-6 text-black cursor-pointer"
                              >
                                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                              </svg>
                            )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <br></br>

              <TextArea
                title="Remarks"
                name="remarks"
                placeholder="Remarks"
                row={2}
                // tabIndex="1"
                maxLength={500}
                content={formFields.remarks}
                controlFunc={handleInputChangeForm}
                controlFuncBlur={handleBlur}
              />

              {/*<LaundryPopup data={popUpData} data1={popUpDataDD} />  */}

              <div className="col-span-2 flex justify-center mt-6 gap-4">
                <Buttons
                  addScreenTitle={AddScreenTitle}
                  viewSaveButton={false}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
              </div>
            </form>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={laundryData}
      >
        <div>
          <PopUpScreenTitle
            title="Laundry"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <LaundryPopup data={laundryrecord} data1={popUpDataDD} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
        {}
      </MainPopup>
    </MainLayout>
  );
};

export default Laundry;
